"use client";

import styled, { css } from "styled-components";
import Box from "../Box/Box";
import { getResponsiveSpacing, getVariations } from "../utils";
import { VariableComponent } from "../ComponentProps";
import { Devices } from "../../constants/styles";

function variableStyle(props: FlexProps) {
  return css`
    flex-wrap: ${props.flexWrap};
    flex-direction: ${props.flexDirection};
    align-items: ${props.alignItems};
    justify-content: ${props.justifyContent};
    gap: ${getResponsiveSpacing(Devices.desktop, props.gap)};
    ${Devices.mediaQueryForDevice(Devices.tablet)} {
      gap: ${getResponsiveSpacing(Devices.tablet, props.gap)};
    }
    ${Devices.mediaQueryForDevice(Devices.mobile)} {
      gap: ${getResponsiveSpacing(Devices.mobile, props.gap)};
    }
    ${getVariations(props, variableStyle)}
  `;
}

export type FlexProps = VariableComponent<{
  flexDirection?: string;
  flexWrap?: string;
  alignItems?: string;
  padding?: string;
  justifyContent?: string;
  gap?: string;
}>;

const Flex = styled(Box)<FlexProps>`
  // TODO: This display value overrides display values in variations
  // One workaround is to do variations: { "mq.s": { display: "none !important" } }
  // Perhaps there is a way to handle this internally though
  display: flex;
  ${variableStyle}
`;

export default Flex;
